import { commonValidation } from './validationRule';

export const GlobalValidation = {
  Name: commonValidation({
    required: true,
    noBlank: true,
    doubleSpace: true,
    textLimit: 100,
  }),
  Email: commonValidation({ required: true, email: true }),
  Phone: commonValidation({
    required: true,
    numericPhone: true,
    noBlank: true,
  }),
  NonRequiredPhone: commonValidation({
    required: false,
    numericPhone: true,
    noBlank: true,
  }),
  Description: commonValidation({ required: false, textLimit: 1000 }),
  ZipCode: commonValidation({ required: true, digits: true, noBlank: true, min: 5, max: 5 }),
  AddressLine1: commonValidation({
    required: true,
    noBlank: true,
    doubleSpace: true,
    addressValidation: true,
  }),
  AddressLine2: commonValidation({
    required: false,
    noBlank: true,
    doubleSpace: true,
    addressValidation: true,
  }),
  RequiredNoBlank: commonValidation({ required: true, noBlank: true }),
  RequiredNoBlankAlphanumeric: commonValidation({
    required: true,
    alphanumeric: true,
    noBlank: true,
  }),
  NoBlankAlphanumeric: commonValidation({
    required: true,
    alphanumeric: true,
    noBlank: true,
  }),
  ValidateSSN: commonValidation({
    required: true,
    alphanumeric: true,
    noBlank: true,
  })
    .min(11, 'Must be 9 digits')
    .max(11, 'Must be 9 digits'),
  Date: commonValidation({
    required: true,
    isDate: true,
  }),
};
